import React from "react";
import { Helmet } from "react-helmet";
import Logo from "../../assets/img/logos/logoColor.png";

// import components
import HouseList from "../../components/HouseList";
import Location from "../../components/Location";
import HeroSlider from "../../components/HeroSlider/HeroSlider";

const Home = () => {
  return (
    <>
      {/* SEO Metadatos */}
      <Helmet>
        <title>Zapiola Fernando Inmobiliaria</title>
        <meta
          name="description"
          content="Descubre las mejores propiedades en venta y alquiler. Casas, departamentos y más en Inmobiliaria Zapiola Fernando."
        />
        <meta
          name="keywords"
          content="inmobiliaria, casas en venta, departamentos, alquiler, bienes raíces, propiedades"
        />
        <meta
          property="og:title"
          content="Inmobiliaria Zapiola Fernando - Chascomús tu lugar en el mundo"
        />
        <meta
          property="og:description"
          content="Descubre las mejores propiedades en venta y alquiler. Casas, departamentos y más en Inmobiliaria Zapiola Fernando."
        />
        <meta
          property="og:image"
          content={Logo} // Actualiza con la URL de tu imagen
        />
        <meta
          property="og:url"
          content="https://www.zapiolainmobiliaria.com.ar"
        />
      </Helmet>

      <HeroSlider />
      <div className="sm:pt-6 bg-[#293445]">
        <HouseList />
      </div>

      <div className="max-w-[1440px] mx-auto mt-6">
        <Location />
      </div>
    </>
  );
};

export default Home;
